export const GRX_CHAIN_ID = 1110

// Keep this existing name because other frontend files already import it.
export const ROBINHOOD_CHAIN_ID = 46630
export const ROBINHOOD_TESTNET_CHAIN_ID = ROBINHOOD_CHAIN_ID

export const ROBINHOOD_MAINNET_CHAIN_ID = 4663

export const ROBINHOOD_MAINNET_AGGREGATOR =
  '0xB4bb2Df83fb53E96Eab6E69AE88E216B8116483C'

export const SUPPORTED_CHAIN_IDS = [
  GRX_CHAIN_ID,
  ROBINHOOD_TESTNET_CHAIN_ID,
  ROBINHOOD_MAINNET_CHAIN_ID,
]

export const CHAIN_CONFIG = {
  [GRX_CHAIN_ID]: {
    chainId: GRX_CHAIN_ID,
    name: 'GRX Chain',
    chainName: 'GRX Chain Mainnet',
    nativeCurrency: {
      name: 'GRX',
      symbol: 'GRX',
      decimals: 18,
    },
    rpcUrls: ['https://rpc.grxchain.io/'],
    explorerUrls: ['https://grxscan.io/'],
    router: '0x28fC93b8a20570f2B59d5CA9f8a1dA02C4DBcDF5',
    wrappedNative: '0x45C7287F897B3A79Cd3f6e4F14B4CE568f023bD5',
  },

  [ROBINHOOD_TESTNET_CHAIN_ID]: {
    chainId: ROBINHOOD_TESTNET_CHAIN_ID,
    name: 'Robinhood Testnet',
    chainName: 'Robinhood Chain Testnet',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://rpc.testnet.chain.robinhood.com/rpc'],
    explorerUrls: ['https://explorer.testnet.chain.robinhood.com'],
    router: '0x49e7fc1466fc9ec82cc6f5e5b368f33f07007559',
    wrappedNative: '0x458a1AC838d22a4A236Df64B2fb1F1Af5b473Ced',
  },

  [ROBINHOOD_MAINNET_CHAIN_ID]: {
    chainId: ROBINHOOD_MAINNET_CHAIN_ID,
    name: 'Robinhood Mainnet',
    chainName: 'Robinhood Chain Mainnet',
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
    },
    rpcUrls: ['https://rpc.mainnet.chain.robinhood.com'],
    explorerUrls: ['https://robinhoodchain.blockscout.com'],
    router: '0x872a7222E5ecBD8366b4341d2e9c8bc8b17fbE8e',
    wrappedNative: '0x0Bd7D308f8E1639FAb988df18A8011f41EAcAD73',
  },
} as const

export type SupportedChainId = keyof typeof CHAIN_CONFIG

export const isSupportedChainId = (
  chainId?: number,
): chainId is SupportedChainId =>
  chainId === GRX_CHAIN_ID ||
  chainId === ROBINHOOD_TESTNET_CHAIN_ID ||
  chainId === ROBINHOOD_MAINNET_CHAIN_ID

export const isRobinhoodChain = (
  chainId?: number,
): boolean =>
  chainId === ROBINHOOD_TESTNET_CHAIN_ID ||
  chainId === ROBINHOOD_MAINNET_CHAIN_ID

export const getRouterAddress = (
  chainId?: number,
): string | undefined =>
  isSupportedChainId(chainId)
    ? CHAIN_CONFIG[chainId].router
    : undefined

export const getSwapSpenderAddress = (
  chainId?: number,
): string | undefined =>
  chainId === ROBINHOOD_MAINNET_CHAIN_ID
    ? ROBINHOOD_MAINNET_AGGREGATOR
    : getRouterAddress(chainId)
